import React from "react";
import { Box, Icon, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { NavTab, NavTabs } from "./nav-tab";
import MobileDrawer from "./mobile-drawer";

// Routes.
import { Link, useLocation } from "react-router-dom";
import { PATH_WEBPAGE } from "../routes/paths";


// ---------------------------------------------------------

const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Tabs.
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // https://stackoverflow.com/a/76166816
  // https://stackoverflow.com/a/70151723
  const { pathname } = useLocation();
  const [[, currentRoot]] = pathname.matchAll(/^(\/[^/]*)/g);

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#e60012",
          height: 30,
          width: "100vw",
          maxWidth: "100%", // This is very Important else there will be the 100vw scrollbar issue.
        }}
        zIndex={"100"}
      >
        <Stack
          sx={{ height: "100%" }}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          {/* Homepage w Name */}
          {/* --------------- */}
          <Link
            to="https://vindorable.me/#/home" // For link preview at bottom.
            onClick={(e) => {
              e.preventDefault(); // Prevents page reload/hash jump.
              window.open("https://vindorable.me/#/home", "_blank")
            }}
            style={{
              color: "inherit",
              textDecoration: "inherit",
              height: "100%",
              display: "flex",
              alignItems: "stretch"
            }}
          >
            <Tooltip
              title="DEV WEBSITE"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: theme.palette.background.defaultInverse,
                    color: theme.palette.background.default,
                  }
                },
                arrow: {
                  sx: {
                    color: theme.palette.background.defaultInverse,
                  }
                }
              }}
            >
              <Stack
                direction={"row"}
                spacing={1}
                alignItems={"center"}
                sx={{
                  height: "100%",
                  px: 2,
                  "&:hover": {
                    backgroundColor: "#8b0000",
                    transition: "color 0.2s ease-in-out",
                  }
                }}
              >
                <Typography variant="body" fontWeight={"600"} fontSize={"1.2rem"} color={theme.palette.background.default} >
                  JAY RAJ
                </Typography>
              </Stack>
            </Tooltip>
          </Link>


          {/* Navigation Tabs */}
          {/* --------------- */}
          <Stack direction={"row"} spacing={2} alignItems={"center"} justifyContent={"center"}>
            {isMobile ? (
              <MobileDrawer />
            ) : (
              <>
                <NavTabs value={currentRoot} onChange={handleChange}>
                  <NavTab label="Wiki.gg" component={Link}
                    to={"https://dinowithagun.wiki.gg/"} // For link preview at bottom.
                    onClick={(e) => {
                      e.preventDefault(); // Prevents page reload/hash jump.
                      window.open("https://dinowithagun.wiki.gg/", "_blank")
                    }}
                  />
                </NavTabs>
              </>
            )}
          </Stack>
        </Stack>
      </Box>
    </>
  );
}


// ---------------------------------------------------------

export default Navbar;